import { useEffect, useState } from 'react';
import type { IGasPriceToPreview, IRangeCurrency } from 'src/interfaces/gas-price.model';

export function useRangeValues(gasPrice: IGasPriceToPreview, loading: boolean) {
  const [rangeFiat, setRangeFiat] = useState<IRangeCurrency | null>(null);
  const [rangeNative, setRangeNative] = useState<IRangeCurrency | null>(null);

  useEffect(
    () => {
      if (loading) {
        setRangeFiat({
          start: rangeFiat?.end ?? 0,
          end: 0,
        });
        setRangeNative({
          start: rangeNative?.end ?? 0,
          end: 0,
        });
      } else {
        if (rangeNative?.start === gasPrice.price) {
          setRangeNative({
            start: 0,
            end: gasPrice.price,
          });
        }
        if (rangeFiat?.start === gasPrice.price) {
          setRangeFiat({
            start: 0,
            end: gasPrice.fiatPrice,
          });
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading, gasPrice.fiatPrice, gasPrice.price],
  );

  useEffect(
    () => {
      setRangeFiat({
        start: rangeFiat?.end ?? 0,
        end: gasPrice.fiatPrice,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gasPrice.fiatPrice],
  );

  useEffect(
    () => {
      setRangeNative({
        start: rangeNative?.end ?? 0,
        end: gasPrice.price,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gasPrice.price],
  );

  return { rangeFiat, rangeNative };
}
